/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The types for Money Transfer wizard
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { IAccountSelectItem } from '../../../components/AccountSelect/AccountSelectTypes';

export enum EMoneyTransferParamType {
    transferAccountFrom = 'transferAccountFrom',
    transferAccountTo = 'transferAccountTo',
}

export const mapMoneyTransferParamTypeToApiAction: { [key in EMoneyTransferParamType]: string } = {
    [EMoneyTransferParamType.transferAccountFrom]: 'search-account-from',
    [EMoneyTransferParamType.transferAccountTo]: 'search-account-to',
};

export interface IMoneyTransferAccountParam {
    accountList: IAccountSelectItem[];
    isLoading: boolean;
    hasMore: boolean;
    errorCode: string;
    message: string;
    searchValue: string;
    selectedAccount: IAccountSelectItem;
}

export interface IMoneyTransferErrorsStepAccount {
    transferAccountFromError: string;
    transferAccountToError: string;
    transferAmountError: string;
}

export interface IMoneyTransferNextAccountPayload {
    data: {
        amount: number;
        from: string;
        to: string;
    };
}

export interface IMoneyTransferNextFinalPayload extends IMoneyTransferNextAccountPayload {
    notify: {
        email?: string;
        phone?: string;
    };
}
